export default __webpack_public_path__ + "profile.svg";